import * as React from 'react';
import { Helmet } from 'react-helmet';

import { GOOGLE_ANALYTICS_ID, REACT_APP_GOOGLE_ADS_ID_CRISPIN, REACT_APP_GTM_ID } from '../../config';

export interface CustomWindow extends Window {
  dataLayer: any[];
  gtag: (...args: any[]) => void;
}

declare var window: CustomWindow;

const dataLayerScript = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
`;

export function GoogleAnalytics() {
  if (GOOGLE_ANALYTICS_ID) {
    return (
      <Helmet>
        <script>
          {`
      ${dataLayerScript}

      gtag('consent', 'default', {
        ad_storage: "denied",
        ad_user_data: "denied", 
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 2000,
      });
      gtag('js', new Date());
      gtag('config', "${GOOGLE_ANALYTICS_ID}",  {
        'linker': {
          'domains': ['support.worldquantbrain.com']
        }
      });
    `}
        </script>
      </Helmet>
    );
  }

  (window as any).gtag = function () {
    console.info('analytic event: ', ...Array.from(arguments));
  };

  return <></>;
}

export const GoogleTagManager = () => {
  if (!REACT_APP_GTM_ID) return null;

  return (
    <Helmet>
      <script>
        {`
      ${dataLayerScript}
      window.dataLayer.push({
      "gtm.start":
      new Date().getTime(), event: "gtm.js"
    })
    `}
      </script>
      <script async src={`https://www.googletagmanager.com/gtm.js?id=${REACT_APP_GTM_ID}`} />
    </Helmet>
  );
};

export const GoogleAds = () => {
  if (!REACT_APP_GOOGLE_ADS_ID_CRISPIN) {
    return null;
  }

  return (
    <Helmet>
      {/* -- Google Ads for Crispin https://jira.worldquant.com/browse/BRAINTECH-2816   -- */}

      <script async src={`https://www.googletagmanager.com/gtag/js?id=${REACT_APP_GOOGLE_ADS_ID_CRISPIN}`}></script>
      <script>
        {`
              ${dataLayerScript}
              gtag('js', new Date());
              gtag('config', '${REACT_APP_GOOGLE_ADS_ID_CRISPIN}', {
                 'linker': {
                    'domains': ['support.worldquantbrain.com']
                }
              });
            `}
      </script>
    </Helmet>
  );
};
